export default {
  copy: 'Copy to clipboard',
};
